import type ImageSizes from "@components/user-image/ImageSizes";
import { mapOvImageSizeToWorkleapMemberAvatarSize } from "@components/user-image/WorkleapMemberAvatarImageSizes";
import { mapOvImageSizeToWorkleapOrganizationLogoSize } from "@components/user-image/WorkleapOrganizationLogoSize";

const getResizedImageUrl = (imageUrl: string | null | undefined, requestedSize: ImageSizes) => {
    if (!imageUrl) {
        return imageUrl;
    }

    if (imageUrl.includes("/user/")) {
        const resizedUrl = imageUrl.replace("/user/", "/user-resized/");
        const imageExtension = resizedUrl.split(".").pop();

        return resizedUrl.replace(`.${imageExtension}`, `_w${requestedSize}_h${requestedSize}.${imageExtension}`);
    } else if (window.env.WORKLEAP_PLATFORM_CDN_URL && imageUrl.startsWith(window.env.WORKLEAP_PLATFORM_CDN_URL)) {
        if (imageUrl.includes("/organization-logos/")) {
            const mappedOrganizationLogoSize = mapOvImageSizeToWorkleapOrganizationLogoSize(requestedSize);
            if (mappedOrganizationLogoSize) {
                const imageExt = imageUrl.split(".").pop();

                return imageUrl.replace(`.${imageExt}`, `_w${mappedOrganizationLogoSize}.${imageExt}`);
            }
        }

        if (imageUrl.includes("/avatars/")) {
            const mappedMemberAvatarSize = mapOvImageSizeToWorkleapMemberAvatarSize(requestedSize);
            if (mappedMemberAvatarSize) {
                const imageExt = imageUrl.split(".").pop();

                return imageUrl.replace(`.${imageExt}`, `_${mappedMemberAvatarSize}x${mappedMemberAvatarSize}.${imageExt}`);
            }
        }
    }

    return imageUrl;
};

export default getResizedImageUrl;
